import { InjectionToken } from '@angular/core';
import { RuntimeConfig } from './runtime-config';

/**
 * La configuration lue au démarrage dans `/config.json`, fournie par `appConfig()`.
 *
 * Pas de valeur par défaut : un service qui l'injecte sans qu'elle ait été fournie doit échouer,
 * plutôt que d'appeler l'API d'un autre environnement.
 */
export const RUNTIME_CONFIG = new InjectionToken<RuntimeConfig>('RUNTIME_CONFIG');
